import React, { useState } from "react";

const BecomeVolunteerForm = () => {

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        role: "",
        bio: "",
    });

    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value, type, files } = e.target;
        setFormData({
            ...formData,
            [name]: type === "file" ? files[0] : value,
        });
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = "Name is required";
        if (!formData.email) newErrors.email = "Email is required";
        if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = "Email is invalid";
        if (!formData.bio) newErrors.bio = "Please tell us about yourself";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validate()) {
            setIsSubmitting(true);
            try {
                const response = await fetch('/api/volunteers', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(formData)
                });

                if (response.ok) {
                    setSuccessMessage("Thank you for applying! Your application will be reviewed by our team.");
                    setErrorMessage("");
                    setFormData({ name: "", email: "", phone: "", role: "", bio: "" });
                } else {
                    const error = await response.json();
                    setErrorMessage(error.error || "Failed to submit application");
                    setSuccessMessage("");
                }
            } catch (error) {
                setErrorMessage("Network error. Please try again.");
                setSuccessMessage("");
            } finally {
                setIsSubmitting(false);
            }
        } else {
            setErrorMessage("Please fix the errors in the form.");
            setSuccessMessage("");
        }
    };

    return (
        <form onSubmit={handleSubmit} className="contact-validation-active" id="contact-form-main">
            <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-6 col-12 form-group">
                    <input
                        type="text"
                        className={`form-control ${errors.name ? "is-invalid" : ""}`}
                        name="name"
                        id="name"
                        placeholder="Full Name *"
                        value={formData.name}
                        onChange={handleChange}
                    />
                    {errors.name && <small className="text-danger">{errors.name}</small>}
                </div>

                <div className="col-lg-6 col-md-6 col-sm-6 col-12 form-group">
                    <input
                        type="email"
                        className={`form-control ${errors.email ? "is-invalid" : ""}`}
                        name="email"
                        id="email"
                        placeholder="Email *"
                        value={formData.email}
                        onChange={handleChange}
                    />
                    {errors.email && <small className="text-danger">{errors.email}</small>}
                </div>

                <div className="col-lg-6 col-md-6 col-sm-6 col-12 form-group">
                    <input
                        type="tel"
                        className="form-control"
                        name="phone"
                        id="phone"
                        placeholder="Phone Number"
                        value={formData.phone}
                        onChange={handleChange}
                    />
                </div>

                <div className="col-lg-6 col-md-6 col-sm-6 col-12 form-group">
                    <select
                        className="form-control"
                        name="role"
                        id="role"
                        value={formData.role}
                        onChange={handleChange}
                    >
                        <option value="">Select Role (Optional)</option>
                        <option value="General Volunteer">General Volunteer</option>
                        <option value="Event Coordinator">Event Coordinator</option>
                        <option value="Youth Programs">Youth Programs</option>
                        <option value="Education">Education</option>
                        <option value="Community Outreach">Community Outreach</option>
                        <option value="Media & Communications">Media & Communications</option>
                        <option value="Facilities">Facilities</option>
                        <option value="Other">Other</option>
                    </select>
                </div>

                <div className="col-lg-12 col-12 form-group">
                    <textarea
                        className={`form-control ${errors.bio ? "is-invalid" : ""}`}
                        name="bio"
                        id="bio"
                        placeholder="Tell us about yourself and why you'd like to volunteer... *"
                        value={formData.bio}
                        onChange={handleChange}
                        rows="5"
                    />
                    {errors.bio && <small className="text-danger">{errors.bio}</small>}
                </div>

                <div className="submit-area col-lg-12 col-12">
                    <button type="submit" className="theme-btn submit-btn" disabled={isSubmitting}>
                        {isSubmitting ? 'Submitting...' : 'Submit Application'}
                    </button>
                    {successMessage && <div className="text-success mt-3">{successMessage}</div>}
                    {errorMessage && <div className="text-danger mt-3">{errorMessage}</div>}
                </div>
            </div>
        </form>
    );
};

export default BecomeVolunteerForm;
